/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_submit_success = /** @type {(inputs: {}) => string} */ () => {
	return `Vaša zpráva byla úspěšně odeslána.`
};

const da_contact_submit_success = /** @type {(inputs: {}) => string} */ () => {
	return `Din besked er sendt.`
};

const de_contact_submit_success = /** @type {(inputs: {}) => string} */ () => {
	return `Ihre Nachricht wurde erfolgreich gesendet.`
};

const en_contact_submit_success = /** @type {(inputs: {}) => string} */ () => {
	return `Your message has been sent successfully.`
};

const es_contact_submit_success = /** @type {(inputs: {}) => string} */ () => {
	return `Tu mensaje ha sido enviado correctamente.`
};

const fr_contact_submit_success = /** @type {(inputs: {}) => string} */ () => {
	return `Votre message a été envoyé avec succès.`
};

const hu_contact_submit_success = /** @type {(inputs: {}) => string} */ () => {
	return `Az üzenetad sikeresen elküldésre került.`
};

const it_contact_submit_success = /** @type {(inputs: {}) => string} */ () => {
	return `Il tuo messaggio è stato inviato con successo.`
};

const nl_contact_submit_success = /** @type {(inputs: {}) => string} */ () => {
	return `Je bericht is succesvol verzonden.`
};

const pl_contact_submit_success = /** @type {(inputs: {}) => string} */ () => {
	return `Twoja wiadomość została wysłana.`
};

const pt_contact_submit_success = /** @type {(inputs: {}) => string} */ () => {
	return `Sua mensagem foi enviada com sucesso.`
};

const sv_contact_submit_success = /** @type {(inputs: {}) => string} */ () => {
	return `Ditt meddelande har skickats.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_submit_success = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_submit_success(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_submit_success", locale)
	if (locale === "cs") return cs_contact_submit_success(inputs)
	if (locale === "da") return da_contact_submit_success(inputs)
	if (locale === "de") return de_contact_submit_success(inputs)
	if (locale === "en") return en_contact_submit_success(inputs)
	if (locale === "es") return es_contact_submit_success(inputs)
	if (locale === "fr") return fr_contact_submit_success(inputs)
	if (locale === "hu") return hu_contact_submit_success(inputs)
	if (locale === "it") return it_contact_submit_success(inputs)
	if (locale === "nl") return nl_contact_submit_success(inputs)
	if (locale === "pl") return pl_contact_submit_success(inputs)
	if (locale === "pt") return pt_contact_submit_success(inputs)
	return sv_contact_submit_success(inputs)
};
export { contact_submit_success as "contact.submit.success" }